export default "__VITE_ASSET__gZXRzKkC__"